import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";

import { SelectList } from "@common/selectList";
import { MilestoneIcon } from "@common/milestoneIcon";
import { EventIcon } from "@common/eventIcon";
import { Safeguard } from "@scenes/safeguard";
import { ElementTypes } from "../types";
import { Props } from "./types";
import { ListIcon } from "./listIcon";
import { TaskIcon } from "./taskIcon";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function ElementTypeSelect({ selectedType, select }: Props) {
  const { t } = useTranslation();

  return (
    <Safeguard
      useCases={[
        UseCases.createTask,
        UseCases.createList,
        UseCases.createMilestone,
        UseCases.createEvent,
      ]}
    >
      {({
        canCreateTask,
        canCreateList,
        canCreateMilestone,
        canCreateEvent,
      }) => (
        <SelectList<ElementTypes> listClassName={styles.listRoot}>
          {({ isOpen, select: s }) => ({
            input: (
              <div
                className={classNames(styles.elementTypeSelect, {
                  [styles.opened]: isOpen,
                })}
              >
                <div className={styles.input}>
                  {selectedType === ElementTypes.TASK ? (
                    <TaskIcon className={styles.icon} />
                  ) : selectedType === ElementTypes.LIST ? (
                    <ListIcon className={styles.icon} />
                  ) : selectedType === ElementTypes.MILESTONE ? (
                    <MilestoneIcon className={styles.icon} />
                  ) : selectedType === ElementTypes.EVENT ? (
                    <EventIcon className={styles.icon} />
                  ) : (
                    <React.Fragment />
                  )}
                  <p className={styles.name}>
                    {selectedType === ElementTypes.TASK
                      ? t("listsList.quickCreation.task")
                      : selectedType === ElementTypes.LIST
                        ? t("listsList.quickCreation.list")
                        : selectedType === ElementTypes.MILESTONE
                          ? t("listsList.quickCreation.milestone")
                          : selectedType === ElementTypes.EVENT
                            ? t("listsList.quickCreation.event")
                            : ""}
                  </p>
                  <ToggleArrow className={styles.toggleArrow} />
                </div>
              </div>
            ),
            list: (
              <div className={styles.list}>
                {canCreateTask && selectedType !== ElementTypes.TASK && (
                  <div
                    className={styles.item}
                    onClick={(e) => {
                      e.stopPropagation();
                      select(s(ElementTypes.TASK));
                    }}
                  >
                    <TaskIcon className={styles.icon} />
                    <p className={styles.name}>
                      {t("listsList.quickCreation.task")}
                    </p>
                  </div>
                )}
                {canCreateList && selectedType !== ElementTypes.LIST && (
                  <div
                    className={styles.item}
                    onClick={(e) => {
                      e.stopPropagation();
                      select(s(ElementTypes.LIST));
                    }}
                  >
                    <ListIcon className={styles.icon} />
                    <p className={styles.name}>
                      {t("listsList.quickCreation.list")}
                    </p>
                  </div>
                )}
                {canCreateMilestone &&
                  selectedType !== ElementTypes.MILESTONE && (
                    <div
                      className={styles.item}
                      onClick={(e) => {
                        e.stopPropagation();
                        select(s(ElementTypes.MILESTONE));
                      }}
                    >
                      <MilestoneIcon className={styles.icon} />
                      <p className={styles.name}>
                        {t("listsList.quickCreation.milestone")}
                      </p>
                    </div>
                  )}
                {canCreateEvent && selectedType !== ElementTypes.EVENT && (
                  <div
                    className={styles.item}
                    onClick={(e) => {
                      e.stopPropagation();
                      select(s(ElementTypes.EVENT));
                    }}
                  >
                    <EventIcon className={styles.icon} />
                    <p className={styles.name}>
                      {t("listsList.quickCreation.event")}
                    </p>
                  </div>
                )}
              </div>
            ),
          })}
        </SelectList>
      )}
    </Safeguard>
  );
}

export { ElementTypeSelect };
